<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="box no-display">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Leaving Certificate </strong>
          <v-icon @click="onload" title="Reload list" dark color="yellow">mdi-reload</v-icon>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center">
        <v-col cols="12" sm="4" md="4" class="mt-3">
          <v-combobox class="no-display" v-model="registration_no" @change="checkHistory" :loading="comp_load" rounded
            :items="stud_list" label="Select Student" item-text="name" outlined dense
            prepend-icon="mdi-account-child-circle"></v-combobox>
        </v-col>
      </v-row>
      <div v-if="registration_no != null">
        <template>
          <v-expansion-panels class="expapanel no-display mb-6" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader">Account History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <v-data-table :headers="headers_1" :items="ay_record" class="elevation-1 mytable" dense>
                  <template v-slot:item.status="{ item }">
                    <v-chip :color="getColor(item.status)" dark>
                      {{ item.status }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-expansion-panels class="expapanel no-display" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader">Academic History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <!-- table content -->

                <v-data-table :headers="headers_2" :items="ay_record_div" dense class="elevation-1 mytable">
                </v-data-table>
                <!-- table end -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>

        <!-- radio button -->
        <v-row justify="center" dense class="no-display">
          <v-radio-group v-model="fetch_gen_toggle" mandatory row class="radiobtn">
            <v-radio label="Fetch LC" value="FETCH"></v-radio>
            <v-radio label="Generate LC" value="GENERATE"></v-radio>
          </v-radio-group>
        </v-row>
        <!-- radio button end -->
        <v-row justify="center" v-if="ay_record.length != 0">
          <div class="fees no-display">
            <span v-if="account_status" style="color: #4caf50">Fees Clear
            </span>
            <span v-else style="color: #f44336">Fees Pending</span>
          </div>
        </v-row>
      </div>
    </v-card>
    <div v-if="registration_no != null">
      <!-- generate lc code -->
      <template v-if="fetch_gen_toggle == 'GENERATE'">
        <!-- Date starts -->
        <v-row justify="center" class="mt-3">
          <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field dense v-model="last_date_of_school" @blur="date = parseDate(last_date_of_school)" v-on="on"
                hint="Last Date of Leaving" prepend-icon="event" persistent-hint></v-text-field>
            </template>
            <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
          </v-menu>

          <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field dense v-model="gen_date" @blur="date = parseDate(gen_date)" v-on="on" hint="Generation Date"
                prepend-icon="event" persistent-hint></v-text-field>
            </template>
            <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
          </v-menu>
          <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-bind="attrs" dense v-model="application_date" @blur="date = parseDate(application_date)"
                v-on="on" hint="Date Of Application" prepend-icon="event" persistent-hint></v-text-field>
            </template>
            <v-date-picker v-model="date_of_application" no-title @input="menu4 = false"
              @change="setToText()"></v-date-picker>
          </v-menu>
          <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-bind="attrs" dense v-model="issue_date" @blur="date = parseDate(issue_date)" v-on="on"
                hint="Date Of Issue" prepend-icon="event" persistent-hint></v-text-field>
            </template>
            <v-date-picker label="Issue Date" v-model="date_of_issue" no-title @input="menu3 = false"
              @change="setToText2()"></v-date-picker>
          </v-menu>
        </v-row>
        <!-- Date ends -->
        <v-row justify="center" class="mt-3">
          <v-col cols="12" sm="3" md="3">
            <v-combobox v-model="progress" rounded :items="dvt_prog" label="Select Progress" outlined dense
              persistent-hint></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox v-model="conduct" rounded :items="dvt_conduct" label="Select Conduct" outlined dense
              persistent-hint></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox v-model="remark" rounded :items="dvt_remark" label="Select Remark" outlined dense
              persistent-hint></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox v-model="reason" rounded :items="dvt_reason" label="Select Reason" outlined dense
              persistent-hint></v-combobox>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-3">
          <v-checkbox color="#0f2027" v-model="mark_inactive"
            label="Do You Want To Mark Student Inactive After Generating LC.?"></v-checkbox>
        </v-row>
        <v-row justify="center">
          <v-btn @click="genLC" :disabled="!condition">Generate LC</v-btn>
        </v-row>
      </template>
      <!-- generate lc code end -->
      <template v-if="fetch_gen_toggle == 'FETCH'">
        <v-btn class="button no-display" @click="fetchLC">Fetch LC</v-btn>
        <br />
      </template>
      <br>
      <div id="document1" class="printdiv cbse" v-if="lc_data != null">
        <div>
          <img :src="lc_data.school_photo_by_section" width="1100px" height="150px" alt="photo">
        </div>
        <!-- <v-row>
          <v-col cols="12" sm="5" md="5">
            <p>{{ org_basic_data.trust_name }}</p>
            <p>{{ org_basic_data.school_name }}</p>
            <span>{{ org_basic_data.address }},</span>
            <span>Ph. No.: <br>{{ org_basic_data.phone }}</span>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <img :src="org_basic_data.school_logo" alt="school_logo" height="80px" width="80px" />
          </v-col>
          <v-col cols="12" sm="5" md="5">
            <p>{{ org_basic_data.trust_name }}</p>
            <p>{{ org_basic_data.school_name }}</p>
            <span>{{ org_basic_data.address }},</span>
            <span>Ph. No.: <br>{{ org_basic_data.phone }}</span>
          </v-col>
        </v-row> -->
        <div class="dotted-line"></div>
        <v-row>
          <v-col cols="12" sm="7" md="7">
            <p>School Reg. No. / शाळा नोंदणी क्र. : {{ org_basic_data.school_no }}</p>
            <br>
            <p>SSC Code / एस. एस. सी. कोड : {{ lc_data.school_ssc_code }}</p>
            <p>UDISE No. / युडायस नं.: {{ lc_data.udise_no }}</p>
          </v-col>
          <v-col cols="12" sm="5" md="5">
            <p>Medium / माध्यम : {{ lc_data.school_medium }} / {{ getMarathiValue('medium', lc_data.school_medium) }}</p>
            <p>E-mail / ई-मेल : {{ org_basic_data.email }}</p>
            <br>
            <p>L.C.No. / एल. सी. क्र. : {{ lc_data.certificate_no }}</p>
            <p>Year / वर्ष : {{ current_ay }}</p>
            <p>G. R. No. / जनरल रजिस्टर क्र. : {{ lc_data.gr_number }}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4" md="4">
            <v-simple-table class="small-table">
              <tr>
                <td style="width: 20%">Original Copy / मूळ प्रत: </td>
                <td colspan="3"></td>
              </tr>
              <tr>
                <td>Duplicate Copy / दुय्यम प्रत:</td>
                <td class="text-center">1</td>
                <td class="text-center">2</td>
                <td class="text-center">3</td>
              </tr>
            </v-simple-table>
          </v-col>
          <v-col cols="12" sm="4" md="4" align="center" style="place-content: end;">
            <h2>शाळा सोडल्याचा दाखला</h2>
            <h2>School Leaving Certificate</h2>
          </v-col>
          <v-col cols="12" sm="2" md="2"></v-col>
        </v-row>
        <v-simple-table class="data-table">
          <tr>
            <td class="index-col">1.</td>
            <td colspan="2">Saral ID / सरल क्रमांक</td>
            <td>{{ lc_data.saral_id }}</td>
            <td colspan="4">PEN No./पेन क्र.{{ lc_data.pen_no }}</td>
          </tr>
          <tr>
            <td class="index-col">2.</td>
            <td colspan="2">Aadhaar No. / आधार क्रमांक</td>
            <td>{{ lc_data.aadhar_no }}</td>
            <td colspan="4">Apaar ID/अपार क्र.{{ lc_data.apaar_id }}</td>
          </tr>
          <tr>
            <td class="index-col">3.</td>
            <td colspan="2">Student's Full Name / <br> विद्यार्थ्यांचे संपूर्ण नाव</td>
            <td colspan="5">{{ lc_data.fullname }} <br> {{ lc_data.marathi_fullname }}</td>
          </tr>
          <tr>
            <td class="index-col">4.</td>
            <td colspan="2">Student's Mother Name / <br> विद्यार्थ्याच्या आईचे नाव</td>
            <td colspan="5">{{ lc_data.mother_first_name }} / {{ lc_data.marathi_mother_first_name }}</td>
          </tr>
          <tr>
            <td class="index-col">5.</td>
            <td colspan="2">Nationality / राष्ट्रीयत्व</td>
            <td>{{ lc_data.nationality }} / {{ lc_data.unicode_nationality }}</td>

            <td class="index-col">6.</td>
            <td colspan="2">Mother Tongue / मातृभाषा</td>
            <td>{{ lc_data.mothertoungue }} / {{ lc_data.unicode_mother_tongue }}</td>
          </tr>
          <tr>
            <td class="index-col">7.</td>
            <td colspan="2">Religion / धर्म</td>
            <td>{{ lc_data.religion }} / {{ lc_data.unicode_religion }}</td>
            <td class="index-col">8.</td>
            <td>Gender / लिंग</td>
            <td colspan="2">{{ lc_data.gender }} / {{ getMarathiValue('gender', lc_data.gender) }}</td>
          </tr>
          <tr>
            <td class="index-col">9.</td>
            <td colspan="2">Caste / जात / Sub Caste / पोटजात</td>
            <td colspan="6">{{ lc_data.caste }} / {{ lc_data.unicode_cast }} / {{ lc_data.subcaste }} / {{
              lc_data.unicode_subcast }}</td>
          </tr>
          <tr>
            <td class="index-col" rowspan="2">10.</td>
            <td colspan="2" rowspan="2">Place of Birth / जन्म ठिकाण</td>

            <td colspan="2">
              Village / City : {{ lc_data.birth_place }} <br>
              गाव / शहर : {{ lc_data.unicode_birth_place }}<br><br>

              Taluka : {{ lc_data.birth_taluka }} <br>
              तालुका : {{ lc_data.unicode_birth_taluka }}
            </td>

            <td colspan="4">
              District : {{ lc_data.birth_district }} <br>
              जिल्हा : {{ lc_data.unicode_birth_district }}<br>

              State : {{ lc_data.birth_state }} <br>
              राज्य : {{ lc_data.unicode_birth_state }}<br>

              Country : {{ lc_data.birth_country_new }} <br>
              देश : {{ lc_data.unicode_birth_country }}
            </td>
          </tr>
          <tr></tr>
          <tr>
            <td class="index-col" rowspan="2">11.</td>
            <td rowspan="2">
              Date of Birth / <br>
              जन्मदिनांक
            </td>
            <td>
              As per Gregorian Calendar / <br>
              ईसवी सन प्रमाणे
            </td>
            <td>
              {{ lc_data.dob_fig }}
            </td>
            <td colspan="4">
              In words : {{ lc_data.dob_words }} <br>
              अक्षरी : {{ lc_data.dob_in_words_marathi }}
            </td>
          </tr>
          <tr>
            <td>
              As per Indian Solar Calendar <br>
              / भारतीय सौर प्रमाणे जन्मदिनांक
            </td>
            <td colspan="5">
              {{ lc_data.dob_indian }}
            </td>
          </tr>
          <tr>
            <td class="index-col">12.</td>
            <td colspan="2">Previous School / यापूर्वीची शाळा</td>
            <td colspan="5">{{ lc_data.last_school }} <br> {{ lc_data.unicode_previous_school_name }}</td>
          </tr>
          <tr>
            <td class="index-col">13.</td>
            <td colspan="2">Standard in which studying / <br> कोणत्या इयत्तेत शिकत होता / होती</td>
            <td>STD - {{ lc_data.standard }} / {{ lc_data.standard_in_marathi }}</td>
            <td colspan="2">Since when (No.)/ <br> कधी पासून (अक्षरी)</td>
            <td colspan="2">{{ lc_data.physical_date }} <br> {{ lc_data.unicode_physical_date }}</td>
          </tr>
          <tr>
            <td class="index-col">14.</td>
            <td colspan="2">Date of Admission / प्रवेशाचा दिनांक</td>
            <td>{{ lc_data.doa }}</td>
            <td colspan="4"> Standard : {{ lc_data.admittedstandard }}<br> इयत्ता : {{
              lc_data.admittedstandard_in_marathi
              }}</td>
          </tr>
          <tr>
            <td class="index-col">15.</td>
            <td colspan="2">Progress / विद्यार्थ्यांची या शाळेतील प्रगती</td>
            <td colspan="5">{{ lc_data.progress }}</td>
          </tr>
          <tr>
            <td class="index-col">16.</td>
            <td colspan="2">Conduct / विद्यार्थ्यांची या शाळेतील वर्तणूक</td>
            <td colspan="5">{{ lc_data.conduct }}</td>
          </tr>
          <tr>
            <td class="index-col">17.</td>
            <td colspan="2">Date of Leaving / शाळा सोडल्याचा दिनांक</td>
            <td>In Figures / <br> अंकी : {{ lc_data.last_date_of_school }}</td>
            <td colspan="4">In words: {{ lc_data.last_date_of_school_in_words }}<br> अक्षरी : {{
              lc_data.last_date_of_school_in_marathi }}</td>
          </tr>
          <tr>
            <td class="index-col">18.</td>
            <td colspan="2">Reason of Leaving / शाळा सोडल्याचे कारण</td>
            <td colspan="5">{{ lc_data.reason }}</td>
          </tr>
          <tr>
            <td class="index-col">19.</td>
            <td colspan="2">Remark / शेरा</td>
            <td colspan="5">{{ lc_data.remark }}</td>
          </tr>
        </v-simple-table>
        <small>
          Note : No change in any entry to be made except by the authority issuing the leaving certificate and that
          infringement of this
          requirement is liable to incur the imposition of penalty. Certified that the above information is in
          accordance
          with the
          School General Register.
        </small>
        <br>
        <small>
          टीप : वरील माहिती शाळेच्या जनरल रजिस्टर मधील नोंदी प्रमाणे आहे. शाळा सोडल्याच्या दाखल्यामध्ये अनधिकृतरित्या
          बदल
          केल्यास संबंधितांवर कायदेशीर कारवाई करण्यात येईल.
        </small>
        <v-row style="margin-top: 50px;">
          <v-col cols="4" class="text-left">
            <div style="height: 45px;"></div>
            <div>Date / दिनांक : {{ lc_data.date_of_issue }}</div>
            <div>Place / ठिकाण :</div>
          </v-col>
          <v-col cols="4" class="text-center">
            <div style="height: 45px;"></div>
            <div>लेखनिक</div>
            <div>
              Clerk <br>
              ({{ lc_data.clerk_name }}) <br>
              ({{ lc_data.clerk_unicode_name }})
            </div>
          </v-col>
          <v-col cols="4" class="text-center">
            <div style="height: 45px;">
                <img :src="awspath + lc_data.head_master_sign" height="45"/>
            </div>
            <div>मुख्याध्यापक</div>
            <div>
              Headmaster <br>
              ({{ lc_data.head_master_name }}) <br>
              ({{ lc_data.head_master_unicode_name }})
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <br>
    <div class="no-display" v-if="lc_data != null">
      <div style="text-align: center">
        ----------------------------------Modify------------------------------------
      </div>
      <br />

      <v-row justify="center" class="mt-3">
        <v-col cols="12" sm="3" md="3">
          <v-text-field label="Student Progress" v-model.trim="lc_data.progress"></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field label="Conduct" v-model.trim="lc_data.conduct"></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field label="Student Remark" v-model.trim="lc_data.remark"></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field label="Student Reason" v-model.trim="lc_data.reason"></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="student_result_status">
        <v-col cols="12" sm="3" md="3">
          <v-select label="Result Status" v-model.trim="lc_data.result_status" :items="result_status_list"
            item-text="name" item-value="name"></v-select>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn class="mb-2 button" color="warning" @click="savegenLC()" small>Save</v-btn>
      </v-row>
      <hr />
      <v-row class="no-display">
        <v-col cols="12" sm="3" md="3">
          <v-text-field label="Birth in words" v-model.trim="lc_data.dob_words"></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field label="Last School" v-model.trim="lc_data.last_school"></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field label="Standard" v-model.trim="lc_data.standard"></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field label="Since when..." v-model.trim="lc_data.standard_since_when"></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field label="Caste" v-model.trim="lc_data.caste"></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field label="Religion" v-model.trim="lc_data.religion"></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-btn @click="proceed" class="info">Proceed to print</v-btn>
      </v-row>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      mark_inactive: false,
      headers_1: [
        { text: "Academic Year", value: "ay" },
        { text: "Paid", value: "paid" },
        { text: "Balance", value: "balance" },
        { text: "Status", value: "status" },
      ],
      headers_2: [
        { text: "Academic Year", value: "ay" },
        { text: "Roll No", value: "rollno" },
        { text: "Div", value: "div" },
        { text: "Std", value: "std" },
        { text: "Total", value: "total" },
        { text: "Present ", value: "present" },
      ],

      comp_load: false,
      fetch_loader: false,
      overlay: false,
      snackbar: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      registration_no: null,
      stud_list: [],
      ay_record: [],
      ay_record_div: [],
      account_status: false,
      dvt_prog: [],
      progress: null,
      dvt_conduct: [],
      conduct: null,
      dvt_reason: [],
      reason: null,
      result_status: null,
      result_status_list: [
        { name: "Pass", id: 1 },
        { name: "Fail", id: 2 },
      ],
      student_result_status: false,
      dvt_remark: [],
      remark: null,
      fetch_gen_toggle: "FETCH",
      board_toggle: "SSC",
      //////date
      last_date_of_school: "",
      gen_date: "",
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      date_of_application: new Date().toISOString().substr(0, 10),
      date_of_issue: new Date().toISOString().substr(0, 10),
      application_date: "",
      issue_date: "",
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      nowDate: new Date().toISOString().slice(0, 10),
      ///
      lc_data: null,
      current_ay: null,
      org_basic_data: null,
      condition: false,
      org_id: null,
      awspath: null
    };
  },
  watch: {
    date(val) {
      this.last_date_of_school = this.formatDate(this.date);
    },
    date2(val) {
      this.gen_date = this.formatDate(this.date2);
    },
    date_of_application(val) {
      this.application_date = this.formatDate(this.date_of_application);
      this.lc_data.date_of_application = this.application_date;
    },
    date_of_issue(val) {
      this.issue_date = this.formatDate(this.date_of_issue);
      this.lc_data.date_of_issue = this.issue_date;
    },
  },
  methods: {
    getMarathiValue(type, value) {
      const mappings = {
        // nationality: {
        //     "Indian": "भारतीय"
        // },
        gender: {
          "Male": "पुरुष",
          "Female": "स्त्री"
        },
        medium: {
          "English": "इंग्रजी",
          "Marathi": "मराठी"
        },
        mothertongue: {
          "Marathi": "मराठी",
          "Hindi": "हिंदी",
          "English": "इंग्रजी"
        }
      }

      if (
        mappings[type] &&
        mappings[type][value]
      ) {
        return mappings[type][value];
      }

      return value;
    },
    setToText() {
      this.lc_data.date_of_application = this.application_date;
    },
    setToText2() {
      this.lc_data.date_of_issue = this.issue_date;
    },
    savegenLC() {
      const formData = {
        lid: this.registration_no.lid,
        progress: this.lc_data.progress,
        conduct: this.lc_data.conduct,
        remark: this.lc_data.remark,
        reason: this.lc_data.reason,
        gen_date: this.date_of_generation,
      };
      if (this.student_result_status) {
        formData.result_status = this.lc_data.result_status;
      }
      this.overlay = true;
      axios
        .post("/certificate/genLC", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.lc_data = res.data.lc_data;
            this.current_ay = res.data.current_ay;
            // this.lc_data.last_school = this.org_basic_data.school_name;
            this.showSnackbar("green", "Saved Successfully..!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    proceed() {
      localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
      localStorage.setItem("current_ay", this.current_ay);
      localStorage.setItem(
        "org_basic_data",
        JSON.stringify(this.org_basic_data)
      );
      let routeData = this.$router.resolve({ name: "des-lc-print" });
      window.open(routeData.href, "_blank");
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    getColor(status) {
      if (status === "pending") return "red";
      if (status === "clear") return "green";
      if (status === "NA") return "gray";
    },

    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },

    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    onload() {
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      this.comp_load = true;
      axios
        .post("/admission/getAllStudents")
        .then((res) => {
          if (res.data.msg == "200") {
            this.stud_list = res.data.all_stud_list;
          } else {
            this.showSnackbar("red", "Something went wrong.");
          }
          this.comp_load = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.comp_load = false;
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    checkHistory() {
      console.log("registration_no:", this.registration_no);
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      if (this.registration_no == null) {
        this.showSnackbar("red", "Please select student");
      }
      this.overlay = true;
      axios
        .post("/certificate/checkHistory", this.registration_no)
        .then((res) => {
          console.log("res", res.data);
          if (res.data.flag == "YES") {
            this.ay_record = res.data.ay_record;
            this.account_status = res.data.account_status;
            this.ay_record_div = res.data.ay_record_div;
            this.dvt_prog = res.data.dvt_prog;
            this.progress = this.dvt_prog[0];
            this.dvt_conduct = res.data.dvt_conduct;
            this.conduct = this.dvt_conduct[0];
            this.dvt_reason = res.data.dvt_reason;
            this.reason = this.dvt_reason[0];
            this.dvt_remark = res.data.dvt_remark;
            this.remark = this.dvt_remark[0];
            this.condition = res.data.condition;
            if (!this.condition)
              this.showSnackbar("red", res.data.condition_msg);
          } else {
            this.showSnackbar("red", res.data.snackbar);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    genLC() {
      if (this.account_status == false) {
        if (
          !confirm(
            "Are You Sure You Want To generate LC as fees is pending...?"
          )
        )
          return;
      }
      if (
        this.progress != null &&
        this.conduct != null &&
        this.last_date_of_school != "" &&
        this.gen_date != "" &&
        this.remark != null &&
        this.reason != null &&
        this.application_date != "" &&
        this.issue_date != ""
      ) {
        const formData = {
          lid: this.registration_no.lid,
          progress: this.progress,
          conduct: this.conduct,
          remark: this.remark,
          reason: this.reason,
          last_date_of_school: this.last_date_of_school,
          gen_date: this.gen_date,
          date_of_application: this.application_date,
          date_of_issue: this.issue_date,
          mark_inactive: this.mark_inactive,
        };
        this.overlay = true;
        axios
          .post("/certificate/genLC", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.org_basic_data = res.data.org_basic_data;
              this.lc_data = res.data.lc_data;
              this.current_ay = res.data.current_ay;
              // this.lc_data.last_school = this.org_basic_data.school_name;
              // if (this.lc_data.caste == null) {
              //   alert("Caste is not enter ..");
              // }
              // this.showSnackbar("green", "User data fetched!!!");
            } else {
              this.showSnackbar("red", res.data.snackbar);
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
            this.overlay = false;
          })
          .catch((error) => {
            this.onerror(error);

            this.overlay = false;
          })
          .finally(() => {
            this.overlay = false;
          });
      } else {
        this.showSnackbar("red", "Please select/enter all data");
      }
    },
    fetchLC() {
      this.overlay = true;
      axios
        .post("/certificate/fetchLC", this.registration_no)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.lc_data = res.data.lc_data;
            this.current_ay = res.data.current_ay;
            // this.lc_data.last_school = this.org_basic_data.school_name;
            this.date_of_application = this.formatDate(
              this.lc_data.date_of_application
            );
            this.date_of_issue = this.formatDate(this.lc_data.date_of_issue);
            this.student_result_status = res.data.student_result_status;
            // this.showSnackbar("green", "User data fetched!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
  mounted() {
    localStorage.setItem("lc_data", null);
    localStorage.setItem("org_basic_data", null);
    localStorage.setItem("last_date_of_school", "");
    this.onload();
    this.last_date_of_school = this.formatDate(this.date);
    this.gen_date = this.formatDate(this.date2);
    this.application_date = this.formatDate(this.date_of_application);
    this.issue_date = this.formatDate(this.date_of_issue);
    this.org_id = localStorage.getItem("EPS-org-id");
    this.awspath = localStorage.getItem("awspath");
  },
};
</script>
<style scoped>
.data-table td.index-col {
  width: 4%;
  white-space: nowrap;
  text-align: center;
}

.dotted-line {
  border-bottom: 2px dotted #000;
  width: 100%;
}

.small-table td {
  border: 1px solid black;
  padding: 0;
  text-align: left;
}

.small-table {
  border: 1px solid black;
}

.small-table td:first-child {
  width: 50%;
}

.data-table td {
  border: 1px solid black;
  text-align: left;
}

.data-table {
  border: 1px solid black;
  text-align: left;
}

.scroll {
  overflow-x: scroll;
}

.mytable /deep/ thead th {
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
  background: #83a4d4;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #265fb1,
      #b6fbff);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #265fb1,
      #b6fbff);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

tr,
td,
th {
  /* border: 1px solid #ccc; */
  text-align: center;
  font-size: small;
}

tr,
tbody {
  font-size: small;
}

td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}

.expapanel {
  width: 93%;
  margin-left: 3%;
}

.panelheader {
  /* background: linear-gradient(to right, #2c5364, #203a43, #0f2027); */
  color: white !important;
  background: #83a4d4;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #3792c7,
      #60e3eb,
      #a0dfe3);
  /* Chrome 10-25, Safari 5.1-6 */
  /* background: linear-gradient(to right,  #83a4d4, #a0dfe3); W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  font-size: 16px;
  background: linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3);
}

.fees span {
  font-size: 23px;
  font-weight: 600;
}

/* lc data css */
.printdiv {
  height: auto;
  margin-left: 10%;
  margin-right: 10%;
  padding: 30px;
  /* border: 1px solid black; */
  background-color: white;
  font-weight: 500;
}

.header {
  margin: 6px;
}

.last-row {
  display: flex;
  justify-content: space-around;
  width: 100%;
  /* margin-bottom: -15px; */
}

.content {
  padding-bottom: 10px;
}

p {
  margin: 0;
}

@media print {

  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  body,
  tr,
  th,
  td {
    font-size: x-large !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  v-card {
    border: none !important;
  }

  p {
    font-size: 17px !important;
  }

  .printdiv {
    margin: 0;
    padding: 0;
  }

  .cbse {
    margin-left: -15px !important;
    width: 102%;
  }

  #document1 {
    position: absolute;
    margin-top: -63px;
    top: 0;
    /* left: 0;
    right: 0; */
    bottom: 0;
  }

  @page {
    size: A4;
    margin: none;
    padding-top: none;
    size: 11.5in 16.5in;
  }
}
</style>